"use client";
import React, { Fragment, useState } from "react";
import Script from "next/script";
import { Center, Spinner } from "@chakra-ui/react";

const PrivacyPolicyPage = ({ nonce }: { nonce?: string }) => {
  const [isLoading, setLoading] = useState(true);
  const onLoad = () => {
    setLoading(false);
  };

  return (
    <Fragment>
      {isLoading && (
        <Center minH={"100vh"}>
          <Spinner size="xl" />
        </Center>
      )}
      <Script
        nonce={nonce}
        onLoad={onLoad}
        onReady={onLoad}
        src="https://cdn.iubenda.com/iubenda.js"
        strategy="afterInteractive"
      />
      <Center>
        <a
          href="https://www.iubenda.com/privacy-policy/31480751"
          className="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed"
          title="Privacy Policy"
        >
          {isLoading ? "" : "Privacy Policy"}
        </a>
      </Center>
    </Fragment>
  );
};

export default PrivacyPolicyPage;
